import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { set_customer } from "../../store/actions/action";
import {
  remove_cust_add,
  save_customer_list,
} from "../../utils/customer_helper";
import "../../assets/css/AddressPopup.css";

export default function AddressPopup(props) {
  const { openUserAddInfo, setOpenUserAddInfo, storeInfoConfig } = props;
  const dispatch = useDispatch();

  const [isDesktop, setIsDesktop] = useState(() =>
    typeof window !== "undefined"
      ? window.matchMedia("(min-width: 900px)").matches
      : true
  );

  useEffect(() => {
    if (typeof window === "undefined") return;
    const media = window.matchMedia("(min-width: 900px)");
    const listener = (e) => setIsDesktop(e.matches);
    if (media.addEventListener) {
      media.addEventListener("change", listener);
    } else {
      media.addListener(listener);
    }
    return () => {
      if (media.removeEventListener) {
        media.removeEventListener("change", listener);
      } else {
        media.removeListener(listener);
      }
    };
  }, []);

  const sessionReducer = useSelector((state) => state.sessionReducer) || {};
  const customerReducer = useSelector((state) => state.customerReducer) || {};

  const reduxConfig =
    sessionReducer.store_config ||
    storeInfoConfig ||
    props.sessionReducer?.store_config ||
    {};
  let primaryColor =
    reduxConfig?.general_config?.primary_color ||
    sessionReducer?.store_details?.primary_color ||
    "#E8450A";

  const reduxCustomer = customerReducer?.customer || props.reducer?.customer;
  let parsedData =
    reduxCustomer && Object.keys(reduxCustomer).length > 0
      ? { ...reduxCustomer }
      : null;
  if (!parsedData) {
    parsedData = {};
  }

  const hasSavedAddresses =
    parsedData?.address && parsedData.address.length > 0;

  const [showAddressForm, setShowAddressForm] = useState(!hasSavedAddresses);
  const [formValues, setFormValues] = useState({
    cust_address: "",
    landmark: "",
    _id: null,
  });
  const [addressType, setAddressType] = useState("Other");
  const [addressfieldmsg, setAddressfieldmsg] = useState(false);
  const [landmarkfieldmsg, setLandmarkfieldmsg] = useState(false);

  const [focusedField, setFocusedField] = useState(null);

  // For saved address actions menu
  const [activeMenuAddressId, setActiveMenuAddressId] = useState(null);

  useEffect(() => {
    if (openUserAddInfo) {
      setAddressfieldmsg(false);
      setLandmarkfieldmsg(false);
      if (!hasSavedAddresses) {
        setShowAddressForm(true);
        setFormValues({ cust_address: "", landmark: "", _id: null });
        setAddressType("Other");
      }
    }
  }, [openUserAddInfo, hasSavedAddresses]);

  const handleClosePopup = () => {
    setActiveMenuAddressId(null);
    if (setOpenUserAddInfo) setOpenUserAddInfo(false);
  };

  useEffect(() => {
    if (!openUserAddInfo) return;
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && !showAddressForm) {
        handleClosePopup();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [openUserAddInfo, showAddressForm, setOpenUserAddInfo]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
    if (name === "cust_address" && value) setAddressfieldmsg(false);
    if (name === "landmark" && value) setLandmarkfieldmsg(false);
  };



  const handleCompleteAndProceed = () => {
    setActiveMenuAddressId(null);
    if (setOpenUserAddInfo) setOpenUserAddInfo(false);
    if (props.onAddressSelect) props.onAddressSelect();
  };

  const handleSaveAddress = async () => {
    let isValid = true;
    if (!formValues?.cust_address || formValues.cust_address.trim() === "") {
      setAddressfieldmsg(true);
      isValid = false;
    }
    if (!formValues?.landmark || formValues.landmark.trim() === "") {
      setLandmarkfieldmsg(true);
      isValid = false;
    }
    if (!isValid) return;

    let customerObj =
      parsedData && Object.keys(parsedData).length > 0
        ? { ...parsedData }
        : {};
    customerObj.address = customerObj.address || [];

    const newAddress = {
      type: addressType,
      cust_address: formValues.cust_address.trim(),
      landmark: formValues.landmark.trim(),
    };

    if (formValues?._id) {
      newAddress._id = formValues._id;
      customerObj.address = customerObj.address.map((addr) =>
        addr._id === formValues._id ? newAddress : addr
      );
    } else {
      customerObj.address.push(newAddress);
    }

    const formattedAddress = `${formValues.cust_address.trim()}, ${formValues.landmark.trim()}`;
    customerObj.cust_address = formattedAddress;

    if (customerObj.cust_mobile) {
      const resp = await save_customer_list({ ...customerObj });
      if (resp) {
        if (props?.set_customer) props.set_customer({ ...resp });
        else dispatch(set_customer({ ...resp }));
      } else {
        if (props?.set_customer) props.set_customer({ ...customerObj });
        else dispatch(set_customer({ ...customerObj }));
      }
    } else {
      if (props?.set_customer) props.set_customer({ ...customerObj });
      else dispatch(set_customer({ ...customerObj }));
    }

    handleCompleteAndProceed();
  };

  const handleSelectSavedAddress = (addr) => {
    let customerObj = { ...parsedData };
    const formattedAddress = `${addr.cust_address}, ${addr.landmark || ""}`.replace(/,\s*$/, "");
    customerObj.cust_address = formattedAddress;

    if (props?.set_customer) props.set_customer({ ...customerObj });
    else dispatch(set_customer({ ...customerObj }));

    handleCompleteAndProceed();
  };

  const handleEditSavedAddress = (addr) => {
    setFormValues({
      cust_address: addr.cust_address || "",
      landmark: addr.landmark || "",
      _id: addr._id || null,
    });
    setAddressType(addr.type || "Other");
    setShowAddressForm(true);
    setActiveMenuAddressId(null);
  };

  const handleDeleteSavedAddress = async (selectedAddressItem) => {
    if (!selectedAddressItem) return;

    let customerObj =
      parsedData && Object.keys(parsedData).length > 0 ? { ...parsedData } : {};

    const deletedFormatted = `${selectedAddressItem.cust_address || ""}, ${selectedAddressItem.landmark || ""}`.replace(/,\s*$/, "").trim();

    if (Array.isArray(customerObj.address)) {
      customerObj.address = customerObj.address.filter((addr) => {
        if (selectedAddressItem._id && addr._id) {
          return String(addr._id) !== String(selectedAddressItem._id);
        }
        return (
          String(addr.cust_address || "").trim() !== String(selectedAddressItem.cust_address || "").trim()
        );
      });
    }

    const currentCustAddr = (customerObj.cust_address || "").trim();
    const isDeletedActive =
      currentCustAddr === deletedFormatted ||
      (selectedAddressItem.cust_address && currentCustAddr.includes(selectedAddressItem.cust_address)) ||
      customerObj.address.length === 0;

    if (isDeletedActive) {
      if (customerObj.address && customerObj.address.length > 0) {
        const nextAddr = customerObj.address[0];
        customerObj.cust_address = `${nextAddr.cust_address}, ${nextAddr.landmark || ""}`.replace(/,\s*$/, "").trim();
      } else {
        customerObj.cust_address = "";
      }
    }

    if (props?.set_customer) props.set_customer({ ...customerObj });
    else dispatch(set_customer({ ...customerObj }));

    if (parsedData?.cust_mobile) {
      try {
        let data = {
          cust_mobile: parsedData?.cust_mobile,
          address_id: selectedAddressItem?._id,
        };
        const resp = await remove_cust_add({ ...data });
        if (resp && resp?.customer_details?.data) {
          let CustData = resp.customer_details.data;
          if (isDeletedActive) {
            if (CustData.address && CustData.address.length > 0) {
              const nextAddr = CustData.address[0];
              CustData.cust_address = `${nextAddr.cust_address}, ${nextAddr.landmark || ""}`.replace(/,\s*$/, "").trim();
            } else {
              CustData.cust_address = "";
            }
          }
          if (props?.set_customer) props.set_customer({ ...CustData });
          else dispatch(set_customer({ ...CustData }));
        }
      } catch (err) {
        console.error("Failed to delete address on server:", err);
      }
    }

    setActiveMenuAddressId(null);
  };

  if (!openUserAddInfo) return null;

  const content = (
    <div style={{ display: "flex", flexDirection: "column", width: "100%", fontFamily: "'Satoshi', sans-serif" }}>
      {/* Header */}
      <div className="address-popup-header">
        <h3 className="address-popup-title" style={{ color: primaryColor }}>
          {showAddressForm ? "Enter address details" : "Select an address"}
        </h3>
        <button
          className="address-popup-close-btn"
          onClick={handleClosePopup}
          style={{ color: primaryColor }}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>

      {/* Content Body */}
      <div className="address-popup-body">
        {showAddressForm ? (
          <div className="address-form-container">
            {/* Address Input */}
            <div className="address-input-wrapper">
              <div
                className={`address-input-box ${focusedField === "cust_address" ? "address-input-box-focused" : ""}`}
                style={{ borderColor: focusedField === "cust_address" ? primaryColor : "#E0E0E0" }}
              >
                <div className="address-input-icon">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill={primaryColor}>
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                  </svg>
                </div>
                <input
                  name="cust_address"
                  value={formValues.cust_address}
                  onChange={handleChange}
                  onFocus={() => setFocusedField("cust_address")}
                  onBlur={() => setFocusedField(null)}
                  placeholder="Enter your Address"
                  className="address-input-field"
                />
                {formValues.cust_address && (
                  <button
                    className="address-input-clear-btn"
                    onClick={() => setFormValues((p) => ({ ...p, cust_address: "" }))}
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#888888" strokeWidth="2">
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </button>
                )}
              </div>
              {addressfieldmsg && (
                <div className="address-error-text">
                  Address is required
                </div>
              )}
            </div>

            {/* Landmark Input */}
            <div className="address-input-wrapper">
              <div
                className={`address-input-box ${focusedField === "landmark" ? "address-input-box-focused" : ""}`}
                style={{ borderColor: focusedField === "landmark" ? primaryColor : "#E0E0E0" }}
              >
                <div className="address-input-icon">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill={primaryColor}>
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                  </svg>
                </div>
                <input
                  name="landmark"
                  value={formValues.landmark}
                  onChange={handleChange}
                  onFocus={() => setFocusedField("landmark")}
                  onBlur={() => setFocusedField(null)}
                  placeholder="Enter Landmark"
                  className="address-input-field"
                />
                {formValues.landmark && (
                  <button
                    className="address-input-clear-btn"
                    onClick={() => setFormValues((p) => ({ ...p, landmark: "" }))}
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#888888" strokeWidth="2">
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </button>
                )}
              </div>
              {landmarkfieldmsg && (
                <div className="address-error-text">
                  Landmark is required
                </div>
              )}
            </div>

            {/* Address Type Section */}
            <div className="address-type-section">
              <div className="address-type-heading">
                Address Type
              </div>
              <div className="address-type-options">
                {[
                  {
                    label: "Home",
                    svg: (
                      <svg width="19" height="19" viewBox="0 0 24 24" fill={primaryColor}>
                        <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
                      </svg>
                    ),
                  },
                  {
                    label: "Work",
                    svg: (
                      <svg width="19" height="19" viewBox="0 0 24 24" fill={primaryColor}>
                        <path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z" />
                      </svg>
                    ),
                  },
                  {
                    label: "Other",
                    svg: (
                      <svg width="19" height="19" viewBox="0 0 24 24" fill={primaryColor}>
                        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                      </svg>
                    ),
                  },
                ].map((typeObj) => {
                  const isSelected = addressType === typeObj.label;
                  return (
                    <div
                      key={typeObj.label}
                      onClick={() => setAddressType(typeObj.label)}
                      className="address-type-pill"
                      style={{
                        border: `1.5px solid ${primaryColor}`,
                        backgroundColor: isSelected ? `${primaryColor}15` : "#FFFFFF",
                        fontWeight: isSelected ? 600 : 500,
                        boxShadow: isSelected ? `0px 3px 10px ${primaryColor}30` : "none",
                      }}
                    >
                      {typeObj.svg}
                      <span>{typeObj.label}</span>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Proceed Button */}
            <button
              className="address-submit-btn"
              onClick={handleSaveAddress}
              style={{ backgroundColor: primaryColor }}
            >
              Proceed
            </button>

            {hasSavedAddresses && (
              <button
                className="address-toggle-btn"
                onClick={() => setShowAddressForm(false)}
                style={{ color: primaryColor }}
              >
                View Saved Addresses
              </button>
            )}
          </div>
        ) : (
          /* Saved Addresses List View */
          <div className="saved-address-list">
            <button
              className="add-address-btn"
              onClick={() => {
                setFormValues({ cust_address: "", landmark: "", _id: null });
                setAddressType("Other");
                setShowAddressForm(true);
              }}
              style={{
                border: `1.5px dashed ${primaryColor}`,
                color: primaryColor,
              }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
              <span>Add new address</span>
            </button>

            <div className="saved-address-heading">
              Saved Addresses
            </div>

            {parsedData?.address?.map((addr, idx) => {
              const itemKey = addr._id || addr.cust_address || idx;
              const isMenuOpen = activeMenuAddressId === itemKey;

              return (
                <div
                  key={itemKey}
                  className="saved-address-card"
                  onMouseLeave={() => {
                    if (isMenuOpen) setActiveMenuAddressId(null);
                  }}
                >
                  <div
                    className="saved-address-content"
                    onClick={() => handleSelectSavedAddress(addr)}
                  >
                    <div style={{ color: primaryColor, marginTop: "2px" }}>
                      {addr.type === "Home" ? (
                        <svg width="20" height="20" viewBox="0 0 24 24" fill={primaryColor}>
                          <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
                        </svg>
                      ) : addr.type === "Work" ? (
                        <svg width="20" height="20" viewBox="0 0 24 24" fill={primaryColor}>
                          <path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z" />
                        </svg>
                      ) : (
                        <svg width="20" height="20" viewBox="0 0 24 24" fill={primaryColor}>
                          <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5-2.5-1.12 2.5-2.5 2.5z" />
                        </svg>
                      )}
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div className="saved-address-title">
                        {addr.type || "Address"}
                      </div>
                      <div className="saved-address-desc">
                        {addr.cust_address}
                        {addr.landmark ? `, ${addr.landmark}` : ""}
                      </div>
                    </div>
                  </div>

                  <button
                    className="saved-address-more-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      setActiveMenuAddressId(isMenuOpen ? null : itemKey);
                    }}
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="#888888">
                      <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
                    </svg>
                  </button>

                  {isMenuOpen && (
                    <div className="saved-address-menu">
                      <div
                        className="saved-address-menu-item"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEditSavedAddress(addr);
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = `${primaryColor}12`;
                          e.currentTarget.style.color = primaryColor;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "transparent";
                          e.currentTarget.style.color = "#333333";
                        }}
                      >
                        Edit
                      </div>
                      <div
                        className="saved-address-menu-item"
                        style={{ color: primaryColor }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteSavedAddress(addr);
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = `${primaryColor}18`;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "transparent";
                        }}
                      >
                        Delete
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );

  if (!isDesktop) {
    return (
      <div
        className="address-popup-drawer-overlay"
        onClick={() => {
          if (!showAddressForm) handleClosePopup();
        }}
      >
        <div
          className="address-popup-drawer-card"
          onClick={(e) => e.stopPropagation()}
        >
          {content}
        </div>
      </div>
    );
  }

  return (
    <div
      className="address-popup-overlay"
      onClick={() => {
        if (!showAddressForm) handleClosePopup();
      }}
    >
      <div
        className="address-popup-card"
        onClick={(e) => e.stopPropagation()}
      >
        {content}
      </div>
    </div>
  );
}
